<template>
  <div
    v-if="showLoadingState < 1"
    key="loading state"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingMyCharges"
  >
    <div class="m-dropdown-primary">
      <AtomButtonSecondary
        :button-secondary="buttonSecondary.download"
        @switchDropDown="$dropDown.switchDropDown"
      />
      <div
        class="m-dropdown-content m-dropdown-content-left"
        id="MoleculeEditionBillingMyChargesDropDownExport"
      >
        <section class="m-dropdown-section">
          <ul class="m-dropdown-list">
            <li>
              <a href="#">
                <download-excel
                  :data = "comprobantes"
                  :fields = "fields"
                  :before-generate = "beforeDownload"
                  type = "csv"
                  :name = "printDateCsv"
                >
                  {{ $t('mEditionBillingMyCharges.buttonSecondary.download.subText') }} .csv
                </download-excel>
              </a>
            </li>
            <li>
              <a href="#">
                <download-excel
                  :data = "comprobantes"
                  :fields = "fields"
                  :before-generate = "beforeDownload"
                  :name = "printDateXls"
                >
                  {{ $t('mEditionBillingMyCharges.buttonSecondary.download.subText') }} .xls
                </download-excel>
              </a>
            </li>
          </ul>
        </section>
      </div>
    </div>

    <div class="m-dropdown-primary">
      <AtomButtonSecondary
        :button-secondary="buttonSecondary.filter"
        @switchDropDown="$dropDown.switchDropDown"
      />
      <MoleculeEditionBillingMyChargesDropDownFilters
        @set-filter="btnFilter"
      />
    </div>

    <div class="m-table-primary">
      <table>
        <tr>
          <th class="text-align-left">
            {{ $t('mEditionBillingMyCharges.table.thClient') }}
          </th>
          <th class="text-align-left">
            {{ $t('mEditionBillingMyCharges.table.thDetail') }}
          </th>
          <th class="text-align-left">
            {{ $t('mEditionBillingMyCharges.table.thTotal') }}
          </th>
          <th class="text-align-left">
            {{ $t('mEditionBillingMyCharges.table.thDivisa') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionBillingMyCharges.table.thDate') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionBillingMyCharges.table.thExpirationDate') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionBillingMyCharges.table.thPaymentDate') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionBillingMyCharges.table.thMethod') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionBillingMyCharges.table.thInvoice') }}
          </th>
          <th
            class="text-align-center"
          >
          </th>
        </tr>
        <tr
          v-for="(comprobante, index) in comprobantes"
          :key="index"
          class="row-data"
        >
          <td class="text-align-left">
              <span> {{ comprobante.nombre_cliente }}</span><br>
              <small> {{ comprobante.email_cliente }}</small>
          </td>
          <td class="text-align-left">
            {{ comprobante.concepto_pago }}
          </td>
          <td class="text-align-left text-white-space-nowrap">
            <router-link
              class="invoice-state"
              :to="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.myCharges.subject')}/${index}/${$t('mEditionMenu.billing.myCharges.children.invoice.subedition')}`"
            >
              <span :class="comprobante.pago_estado === 2 ? 'text-color-success' : comprobante.pago_estado === 4 ? 'text-color-danger' : 'text-color-info'">
                {{ comprobante.simbolo }} <!-- Definir parametro a usar -->
                <span class="font-weight-bold">{{ comprobante.monto }}</span>
              </span>
              <span> {{ comprobante.divisa }}</span><br>
              <small> {{ estados_comprobante[comprobante.pago_estado].nombre }}</small>
            </router-link>
          </td>
          <td class="text-align-left">
            {{ comprobante.divisa }} <!-- divisa ISO code -->
          </td>
          <td class="text-align-center text-white-space-nowrap">
            {{ $utils.formatISODateTime(comprobante.fecha_venta) }}
          </td>
          <td class="text-align-center text-white-space-nowrap">
            {{ $utils.formatISODateTime(comprobante.fecha_vencimiento) }}
          </td>
          <td class="text-align-center">
            {{ !comprobante.fecha_pago ? '-' : $utils.formatISODateTime(comprobante.fecha_pago) }}
          </td>
          <td class="text-align-center text-white-space-nowrap">
            {{ comprobante.medio_pago }}
          </td>
          <td class="text-align-center">
            {{ comprobante.tipo_comprobante }}
          </td>
          <td class="text-align-center">
            <div class="m-dropdown-primary"
            >
              <AtomButtonSecondary
                :button-secondary="buttonSecondary.state"
                @ev="$dropDown.switchDropDown(`pago-`+index)"
                :disabled="loading == true"
                v-show="comprobante.pago_estado !== 4 && comprobante.pago_estado !== 3"
              />
              <div
                class="m-dropdown-content m-dropdown-content-right"
                :id="`pago-`+index"
              >
                <section class="m-dropdown-section">
                  <ul class="m-dropdown-list"
                  >
                    <li v-if="comprobante.pago_estado === 0">
                      <a href="#"
                         @click.prevent="confirmarPago(comprobante.id_venta, comprobante.id_pago)"
                      >
                        {{ $t('mEditionBillingMyCharges.toggleState.confirm') }}
                      </a>
                    </li>
                    <li v-if="comprobante.pago_estado === 0">
                      <a href="#"
                         @click.prevent="anularPago(comprobante.id_venta, comprobante.id_pago)"
                      >
                        {{ $t('mEditionBillingMyCharges.toggleState.cancel') }}
                      </a>
                    </li>
                    <li v-if="comprobante.pago_estado === 2">
                      <a href="#"
                         @click.prevent="reembolsarPago(comprobante.id_venta, comprobante.id_pago)"
                      >
                        {{ $t('mEditionBillingMyCharges.toggleState.refund') }}
                      </a>
                    </li>
                  </ul>
                </section>
              </div>
            </div>
          </td>
        </tr>
      </table>
      <MoleculePaginatePrimary/>
    </div>
  </div>

</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyCharges',

  components: {
    MoleculeEditionBillingMyChargesDropDownFilters: () => import('@/components/molecules/MoleculeEditionBillingMyChargesDropDownFilters'),
    MoleculePaginatePrimary: () => import('@/components/molecules/MoleculePaginatePrimary')
  },

  data () {
    return {
      loading: false,
      buttonSecondary: {
        download: {
          class: 'a-button-billing-secondary a-button-side',
          component: 'MoleculeEditionBillingMyChargesDropDownExport',
          icon: 'fas fa-download',
          method: 'switchDropDown',
          text: this.$t('mEditionBillingMyCharges.buttonSecondary.download.text'),
          type: 'button'
        },

        filter: {
          class: 'a-button-billing-secondary a-button-side',
          component: 'MoleculeEditionBillingMyChargesDropDownFilters',
          icon: 'fas fa-filter',
          method: 'switchDropDown',
          text: this.$t('mEditionBillingMyCharges.buttonSecondary.filterText'),
          type: 'button'
        },

        state: {
          class: 'a-button-side',
          component: 'MoleculeEditionBillingMyChargesDropDownState',
          icon: 'fas fa-ellipsis-h',
          method: 'ev',
          type: 'button'
        }
      },

      comprobantes: [],

      estados_comprobante: [
        { id: 0, nombre: 'PENDIENTE' },
        { id: 1, nombre: 'CONFIRMAR' },
        { id: 2, nombre: 'PAGADO' },
        { id: 3, nombre: 'REEMBOLSO' },
        { id: 4, nombre: 'ANULADO' }
      ],

      filtro: {
        buscar: '',
        fecha_desde: '',
        fecha_hasta: '',
        pais: '',
        divisa: [],
        pasarela_pago: [],
        estado: [],
        cupon: '',
        sort_by: '',
        order: '',
        pagina: 1,
        limite: 20
      },

      fields: {
        alumno: 'alumno',
        detalle: 'detalle',
        total: 'total',
        estado: 'estado',
        divisa: 'divisa',
        fecha: 'fecha',
        fecha_vencimiento: 'fecha_vencimiento',
        fecha_pago: 'fecha_pago',
        medio: 'medio',
        tipo_comprobante: 'tipo_comprobante'
      },
      showLoadingState: 0
    }
  },

  computed: {
    paginateCurrentPage () {
      return this.$paginate.getCurrentPage()
    },

    printDateCsv () {
      return `listed__${this.objDate().getDate()}-${this.objDate().getMonth() + 1}-${this.objDate().getFullYear()}__${this.objDate().getHours()}_${this.objDate().getMinutes()}_${this.objDate().getSeconds()}.csv`
    },

    printDateXls () {
      return `listed__${this.objDate().getDate()}-${this.objDate().getMonth() + 1}-${this.objDate().getFullYear()}__${this.objDate().getHours()}_${this.objDate().getMinutes()}_${this.objDate().getSeconds()}.xls`
    }
  },

  watch: {
    paginateCurrentPage () {
      this.showLoadingState = 0
      this.filtro.pagina = this.$paginate.getCurrentPage()
      this.readVentasMisCobros(this.filtro)
    }
  },

  created () {
    this.$paginate.setXpage(this.filtro.limite)
    this.readVentasMisCobros(this.filtro)
  },

  methods: {
    setLoading () {
      this.buttonSecondary.state.icon = 'fas fa-circle-notch fa-spin fa-fw'
      this.loading = true
    },
    setNotLoading () {
      this.buttonSecondary.state.icon = 'fas fa-ellipsis-h'
      this.loading = false
    },
    confirmarPago (idVenta, idPago) {
      this.setLoading()
      this.$services.update('ventas', 'updateVentasConfirmarPago', {}, [idVenta, idPago])
        .then(response => {
          this.$alerts.pushAlert('mEditionBillingMyCharges', 'updateVentasConfirmarPago', 'success')
          this.readVentasMisCobros()
          this.setNotLoading()
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionBillingMyCharges', 'updateVentasConfirmarPago', 'error', 'a-alert-danger')
          this.setNotLoading()
        })
    },

    anularPago (idVenta, idPago) {
      this.setLoading()
      this.$services.update('ventas', 'updateVentasAnularPago', {}, [idVenta, idPago])
        .then(response => {
          this.$alerts.pushAlert('mEditionBillingMyCharges', 'updateVentasAnularPago', 'success')
          this.readVentasMisCobros()
          this.setNotLoading()
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionBillingMyCharges', 'updateVentasAnularPago', 'error', 'a-alert-danger')
          this.setNotLoading()
        })
    },

    reembolsarPago (idVenta, idPago) {
      this.setLoading()
      this.$services.update('ventas', 'updateVentasReembolsarPago', {}, [idVenta, idPago])
        .then(response => {
          this.$alerts.pushAlert('mEditionBillingMyCharges', 'updateVentasReembolsarPago', 'success')
          this.readVentasMisCobros()
          this.setNotLoading()
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionBillingMyCharges', 'updateVentasReembolsarPago', 'error', 'a-alert-danger')
          this.setNotLoading()
        })
    },

    beforeDownload () {
      if (this.comprobantes.length) {
        this.$alerts.pushAlert('mEditionBillingMyChargesInvoice', 'download', 'success')
      } else {
        this.$alerts.pushAlert('mEditionBillingMyChargesInvoice', 'download', 'error', 'a-alert-danger')
      }
    },

    btnFilter (newFilter) {
      if (this.$paginate.getCurrentPage() === 1) {
        this.showLoadingState = 0
        this.filtro = newFilter
        this.readVentasMisCobros(this.filtro)
      } else {
        this.filtro = newFilter
        this.$paginate.setCurrentPage(this.filtro.pagina)
      }
    },

    objDate () {
      let date = new Date()
      return date
    },

    readVentasMisCobros (filter) {
      this.$services.read('ventas', 'readVentasMisCobros', {}, [this.$store.getters.getAcademyData.id], filter)
        .then(response => {
          this.comprobantes = response.data.ventas
          this.$paginate.setTotalPages(response.data.pages)
          this.$paginate.setTotalElements(response.data.total)
          this.$paginate.setLimInf(this.comprobantes.length)
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    }
  }
}
</script>
